import { Toaster as Sonner } from 'sonner';
import { useTheme } from '@/contexts/ThemeContext';

export const Toaster = () => {
  const { resolvedTheme } = useTheme();

  return (
    <Sonner
      theme={resolvedTheme as 'light' | 'dark' | 'system'}
      position="top-right"
      toastOptions={{
        classNames: {
          toast: 'font-body text-sm border shadow-lg',
          success: 'bg-emerald-50 dark:bg-emerald-950 border-emerald-200 dark:border-emerald-800 text-emerald-800 dark:text-emerald-200',
          error: 'bg-rose-50 dark:bg-rose-950 border-rose-200 dark:border-rose-800 text-rose-800 dark:text-rose-200',
          warning: 'bg-amber-50 dark:bg-amber-950 border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-200',
          info: 'bg-blue-50 dark:bg-blue-950 border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-200',
        },
      }}
    />
  );
};
